import DropTargetFactory, { invisibleDropTargetStyle } from "../DropTargetFactory";
import { DragAndDropTypes } from "../types";

export default DropTargetFactory(DragAndDropTypes.InstructionListItem, invisibleDropTargetStyle);
